<ng-container *ngIf="(gridColumns$ | async) && (gridOptions$ | async)">
  <app-grid
    class="statusTrackerContent"
    *ngIf="statusTracker.rows.length && statusTracker.columns.length; else noRowsOrColumns"
    [data]="gridData"
    [columns]="gridColumns$ | async"
    [options]="gridOptions$ | async"
    [filterControls]="gridFilterControls$ | async"
    [stackedHeaderRows]="gridStackedHeaderRows$ | async"
  ></app-grid>

  <ng-template #noRowsOrColumns>
    <div class="px-spacer-responsive py-3 border-top">
      <i i18n="@@dprDetails.dprStatusTrackerGrid.noRowsOrColumns">
        You need at least one active row and column for each status tracker. Go to Project Setup -> Status Tracker in
        order to add or activate any.
      </i>
    </div>
  </ng-template>
</ng-container>

<ng-template #timeComponent let-context>
  <app-time [time]="context.selectedTime" (timeChanged)="context.timeChanged($event)"></app-time>
</ng-template>
